import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`

  const transformOrigin = '4.0967 14.64'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M8.19203 24.51C8.12203 21.33 6.48204 16.99 6.14204 11.38C5.86204 6.87 6.63203 0 6.63203 0H1.56204C1.56204 0 2.32203 6.87 2.05203 11.38C1.71203 16.99 0.0720417 21.32 0.00204173 24.51C-0.0579583 27.03 1.20203 29.28 4.10203 29.28C7.00203 29.28 8.24203 27.03 8.19203 24.51Z"
          fill={`url(#${randomGradientId1})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="4.09034"
            y1="3.6156"
            x2="4.09034"
            y2="30.132"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8488" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
